import React from "react";
import { COLORBAR_GRADIENT } from "./colorbarConstants";
import { CustomColorBar } from "./ColorBarComponent";
import { sunsensors } from "../navBar/NavBar";
import { useSolarSensorsColorBar } from "../CustomHooks";

const ColorBarSolarSensors = () => {
  const { min, max, isVisible, visibleIndex } = useSolarSensorsColorBar();

  return (
    <CustomColorBar
      gradient={
        visibleIndex == 0 ? COLORBAR_GRADIENT.HOURS : COLORBAR_GRADIENT.OTHER
      }
      category="Solar Sensors"
      subcategory={sunsensors[visibleIndex]}
      unit={visibleIndex === 0 ? "Hours" : "kWh/m²a"}
      dataMin={min}
      dataMax={max}
      isVisible={isVisible}
    />
  );
};

export default ColorBarSolarSensors;
